import React from 'react';
import { motion } from 'framer-motion';
import { Coins, HeartHandshake, Scale } from 'lucide-react';

const Feature = ({ icon: Icon, title, description, delay }: { icon: any, title: string, description: string, delay: number }) => (
  <motion.div 
    initial={{ opacity: 0, y: 20 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.5, delay }}
    className="bg-white p-6 md:p-8 rounded-xl border border-slate-100 shadow-sm text-center hover:border-brand-200 transition-colors"
  >
    <div className="w-12 h-12 mx-auto bg-brand-50 rounded-full flex items-center justify-center text-brand-600 mb-4">
      <Icon size={24} />
    </div>
    <h3 className="text-lg font-medium text-slate-900 mb-2">{title}</h3>
    <p className="text-slate-600 leading-relaxed text-sm">{description}</p>
  </motion.div>
);

export const Reassurance: React.FC = () => {
  return (
    <section className="py-12 md:py-16 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          <Feature 
            icon={Coins} 
            title="Geen kosten voor u" 
            description="Onze hulp is kosteloos voor slachtoffers. De aansprakelijke partij vergoedt onze juridische kosten."
            delay={0.1}
          />
          <Feature 
            icon={Scale} 
            title="Specialistische hulp" 
            description="Ervaren juristen die precies weten waar u recht op heeft. Wij nemen de discussie uit handen."
            delay={0.2}
          />
          <Feature 
            icon={HeartHandshake} 
            title="Persoonlijk contact" 
            description="Geen nummer, maar een menselijke benadering. U krijgt een vaste jurist die uw situatie begrijpt."
            delay={0.3}
          />
        </div>
      </div>
    </section>
  );
};